export default "__VITE_ASSET__BA9l_1bO__"